module.exports = __webpack_public_path__ + "images/todo.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/todo.jpg
 ** module id = 54
 ** module chunks = 1
 **/